import { FC, HTMLProps } from 'react';

export const StonksWrappedIcon: FC<HTMLProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="67"
      height="67"
      viewBox="0 0 67 67"
      fill="none"
      {...props}
    >
      <path
        opacity="0.21"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 33.5V41.4939C0 55.5805 11.4195 67 25.5061 67H33.5H41.4939C55.5805 67 67 55.5805 67 41.4939V33.5V25.5061C67 11.4195 55.5805 0 41.4939 0H33.5H25.5061C11.4195 0 0 11.4195 0 25.5061V33.5Z"
        fill="#4AD991"
      />
      <path
        d="M21.4444 45.5556H47.2778C48.2289 45.5556 49 46.3266 49 47.2778C49 48.2289 48.2289 49 47.2778 49H19.7222C18.7711 49 18 48.2289 18 47.2778V19.7222C18 18.7711 18.7711 18 19.7222 18C20.6734 18 21.4444 18.7711 21.4444 19.7222V45.5556Z"
        fill="#4AD991"
      />
      <path
        opacity="0.5"
        d="M27.9649 38.4422C27.3174 39.1533 26.2325 39.1893 25.5418 38.5227C24.8511 37.8561 24.8161 36.7394 25.4637 36.0283L31.8922 28.9696C32.5184 28.2819 33.5591 28.2223 34.2556 28.8341L39.3294 33.2911L45.9401 24.6713C46.5268 23.9063 47.6048 23.7758 48.3479 24.3797C49.091 24.9836 49.2178 26.0933 48.6312 26.8583L40.9169 36.917C40.3144 37.7027 39.1983 37.8157 38.4586 37.1659L33.2745 32.6121L27.9649 38.4422Z"
        fill="#4AD991"
      />
    </svg>
  );
};
